// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import San_Saba from '../../../Texas/data/counties/San_Saba.geo.json'
import Llano from '../../../Texas/data/counties/Llano.geo.json'
import Burnet from '../../../Texas/data/counties/Burnet.geo.json'
import Blanco from '../../../Texas/data/counties/Blanco.geo.json'
import Williamson from '../../../Texas/data/counties/Williamson.geo.json'
import Travis from '../../../Texas/data/counties/Travis.geo.json'
import Hays from '../../../Texas/data/counties/Hays.geo.json'
import Lee from '../../../Texas/data/counties/Lee.geo.json'
import Bastrop from '../../../Texas/data/counties/Bastrop.geo.json'
import Caldwell from '../../../Texas/data/counties/Caldwell.geo.json'
import Fayette from '../../../Texas/data/counties/Fayette.geo.json'

const counties = {
  San_Saba,
  Llano,
  Burnet,
  Blanco,
  Williamson,
  Travis,
  Hays,
  Lee,
  Bastrop,
  Caldwell,
  Fayette
}

export default counties
